module.exports = __webpack_public_path__ + "img/Logo_round.29b55231.svg";